<template>
    <div class="betslip-header">
        <div class="betslip-header__title">
            {{ $t('betSlip') | upperCase }}
        </div>
        <BinarySwitcher
            v-if="hasTypes"
            class="betslip-header__binary-switcher"
            v-bind="switcherOptions"
            @change="onTypeClick"
            :value="value"
        />
        <button
            class="btn collapse-button"
            @click="$emit('collapse')"
        >
            <i class="icon icon-chevron_down" />
        </button>
    </div>
</template>

<script>
    import BinarySwitcher from '@shared/components/BinarySwitcher.vue';
    import { BetSlipType } from '@core/models/shared/betSlip/betSlipEnums';
    import { upperCase } from '@modules/shared/filters';

    export default {
        name: 'BetSlipHeader',
        props: {
            hasTypes: {
                type: Boolean,
                default: true,
            },
            isSimple: {
                type: Boolean,
                default: true,
            },
        },
        created() {
            if (this.$props.hasTypes) {
                this.switcherOptions = {
                    first: {
                        label: upperCase(this.$t('simple')),
                        value: BetSlipType.simple,
                    },
                    second: {
                        label: upperCase(this.$t('system')),
                        value: BetSlipType.system,
                    }
                };
            }
        },
        methods: {
            onTypeClick(type) {
                this.$emit('typeClick', type);
            },
        },
        computed: {
            value() {
                return this.isSimple ? this.switcherOptions.first.value : this.switcherOptions.second.value;
            }
        },
        components: {
            BinarySwitcher
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/BetSlipHeader.vue